<template lang="pug">
  el-dialog(
    width="55%"
    title="Tags Masterlist"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
  )

    el-form(
      ref="newTag"
      :model="form"
      :rules="rules"
      label-position="top"
      style="padding-left: 5%; padding-right: 5%"
    )
      el-row
        el-col(:span="16")
          el-form-item(prop="newTag")
            el-input(
              v-model="form.newTag"
              placeholder="Input a new tag text"
            )
        el-col(:span="8")
          el-button(
            class="primary-button"
            style="float:right;" 
            :loading="submitting" 
            icon="el-icon-circle-plus-outline"
            @click="onSubmitValidate('newTag')") Add Tag      
      el-row(style="margin-top: 20px; border-top: 1px solid; ")
        el-col(:span="24" class="scrollbar-container" id="scrollbar-style")
          tag-option(
            v-for="item in tagsList"
            :key="item.id"
            :text="item.text" 
            :id="item.id"
            @onTagDeleted="deleteTag"
            @onTagUpdated="updateTag")
    
</template>
 

<script>
  import TagOption from '@/components/superadmin/Tags/TagOption'
  import utilMixin from '@/components/mixins/utilMixin'
  
  export default {
    name: 'TagModal',
    
    components: {
      TagOption,
    },

    mixins: [utilMixin],

    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },

      tagsList: {
        type: Array,
        required: true,
      },

      tagId: {
        type: Number,
        default: -1,
      },

      libraryIndex: {
        type: Number,
        required: true,
      },
    },

    data() {
      return {
        form: { 
          newTag: '',
        },
        loading: false,
        submitting: false,
        rules: {
          newTag: [
            { required: true, message: 'Please input the tag text', trigger: 'blur' },
          ],
        },
      }
    },

    computed: {
      isVisible: {
        get() {
          return this.showDialog
        },
        set(value) {
          if (value === false) {
            this.$emit('close')
          }
        },
      },

      modalTitle: function() {
        let title = ''
        if (this.tagId < 0 ) {
          title= "Add a New Tag"
        } else {
          this.tagsList.forEach(item => {
            if ( item.id == this.tagId ) {
              title = ("Edit Tag: " + item.text)
            }
          })
        } 
        return title 
      },
    },

    methods: {
      onSubmitValidate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitting = true
            this.form.newTag = this.form.newTag.toLowerCase()
            this.updateTag(-1,this.form.newTag)
           
          } else {
            this.submitting = false
            return false
          }
        })
      }, 

    deleteTag(id) {
      this.$emit("onTagDeleted",id)
    },

    updateTag( id, text ) {
      let duplicated = false
      for ( let i=0; i<this.tagsList.length; i++) {
        if ( this.tagsList[i].text === text ) {
          duplicated = true
          break
        }
      }

      if ( !duplicated ) {
        let params = {newTag: text,library: this.libraryIndex}
        if ( id >= 0 ) {
          params.id = id
        }

        this.axios.post('/api/tags/' + this.$store.state.canvasData.userId, {params:params})
          .then(() => {
            this.submitting = false
            this.$emit('onTagUpdated',id,text)
            this.mNotification({message:( text + ' tag was saved.')})
            this.form.newTag = ''
          })
          .catch((error) => {
            this.mNotification({error: error, message: 'The new tag was not saved.'})
          })         
      }
      else {
        this.submitting = false
        this.mNotification({error: 'error', message: 'Tag already exists'})
      }
    },  
  },
}
</script>

<style>
  .el-dialog__title {
    color: #3a8ee6;
    font-size: 1.25em;
    padding: 2%;
  }
</style>